export interface AntimalwareAntiTamperingFormValue {
  enabled: boolean;
  vulnerableDrivers: {
    enabled: boolean;
    action: VulnerableDriversAction;
  },
  callbackEvasion: {
    enabled: boolean;
    actions: CallbackEvasionActions;
  }
}

export interface AntimalwareAntiTamperingPanelWebComponentSchema {
  formValue: AntimalwareAntiTamperingFormValue;
}

export interface CallbackEvasionActions {
  isolateEndpoint: boolean;
  rebootEndpoint: boolean;
  rebootTime: RebootTimes;
}

export enum VulnerableDriversAction {
  DENY_ACCESS = 1,
  REMEDIATE = 2,
  REPORT_ONLY = 3,
}

export enum RebootTimes {
  IMMEDIATELY = 0,
  MIN_5 = 5,
  MIN_10 = 10,
  MIN_15 = 15
}

